import { modalRenderer } from '~/modal/modalRendererRegistry';
import { BoundaryGroupsListingContainer } from './boundaryGroupsListing.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryGroupsListing: undefined;
  }
}
modalRenderer.register('BoundaryGroupsListing', BoundaryGroupsListingContainer);
